export enum CreatedByFlowEnum {
    All = '',
    Eots = 'eots',
    Iots = 'iots',
    Lp = 'lp',
    EnergyOptimization = 'energyOptimization',
    Vacancy = 'vacancy',
    Tots = 'tots',
}
